"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var auth_1 = require("firebase/auth");
var react_final_form_1 = require("react-final-form");
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("atomicComponents/atoms/Buttons/Button"));
var LoadingSingle_1 = __importDefault(require("components/LoadingSpinner/LoadingSingle"));
var GoogleButton_1 = __importDefault(require("containers/Authentication/styles/GoogleButton"));
var TextDivider_1 = __importDefault(require("containers/Authentication/styles/TextDivider"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Text_1 = __importDefault(require("shared/components/Text"));
var firestore_1 = require("utils/firebase/firestore");
var firebaseConf_1 = require("utils/firebaseConf");
var validators_1 = require("utils/form/validators");
var hooks_1 = require("utils/hooks");
var logging_1 = require("utils/logging");
var googleProvider = new auth_1.GoogleAuthProvider();
var LoginForm = function (_a) {
    var needsLogin = _a.needsLogin, setLoading = _a.setLoading, redirectPath = _a.redirectPath, fixedEmail = _a.fixedEmail, loading = _a.loading, invId = _a.invId;
    var history = (0, react_router_dom_1.useHistory)();
    var _b = __read((0, hooks_1.useSubmitter)('invitations', invId), 1), updateInv = _b[0];
    var googleLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var userCredential, user, googleProviderData, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, , 6]);
                    return [4 /*yield*/, ((_a = firebaseConf_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.linkWithPopup(googleProvider))];
                case 2:
                    userCredential = _c.sent();
                    user = userCredential === null || userCredential === void 0 ? void 0 : userCredential.user;
                    googleProviderData = (_b = user === null || user === void 0 ? void 0 : user.providerData) === null || _b === void 0 ? void 0 : _b.find(function (usrInf) { return (usrInf === null || usrInf === void 0 ? void 0 : usrInf.providerId) === 'google.com'; });
                    return [4 /*yield*/, (0, firestore_1.setMergeDoc)('users', user === null || user === void 0 ? void 0 : user.uid, {
                            isUnauthUser: false,
                            displayName: (googleProviderData === null || googleProviderData === void 0 ? void 0 : googleProviderData.displayName) || undefined,
                            avatarUrl: (googleProviderData === null || googleProviderData === void 0 ? void 0 : googleProviderData.photoURL) || undefined,
                        })];
                case 3:
                    _c.sent();
                    return [4 /*yield*/, updateInv({ passwordChanged: true, promoted: true })];
                case 4:
                    _c.sent();
                    history.push(redirectPath || '/');
                    return [3 /*break*/, 6];
                case 5:
                    e_1 = _c.sent();
                    (0, logging_1.logError)(e_1);
                    setLoading(false);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var onLogin = function (_a) {
        var password = _a.password;
        return __awaiter(void 0, void 0, void 0, function () {
            var e_2;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        if (!password) {
                            return [2 /*return*/];
                        }
                        setLoading(true);
                        if (!(needsLogin === 'password')) return [3 /*break*/, 1];
                        firebaseConf_1.auth.signInWithEmailAndPassword(fixedEmail, password).catch(function () { return setLoading(false); });
                        return [3 /*break*/, 6];
                    case 1:
                        _d.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, ((_b = firebaseConf_1.auth.currentUser) === null || _b === void 0 ? void 0 : _b.updatePassword(password))];
                    case 2:
                        _d.sent();
                        return [4 /*yield*/, (0, firestore_1.setMergeDoc)('users', (_c = firebaseConf_1.auth.currentUser) === null || _c === void 0 ? void 0 : _c.uid, { isUnauthUser: false })];
                    case 3:
                        _d.sent();
                        return [4 /*yield*/, updateInv({ passwordChanged: true, promoted: true })];
                    case 4:
                        _d.sent();
                        history.push(redirectPath);
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _d.sent();
                        (0, logging_1.logError)(e_2);
                        setLoading(false);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, md: 4 }, { children: [needsLogin !== 'password' && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ my: 2 }, { children: (0, jsx_runtime_1.jsx)(GoogleButton_1.default, __assign({ type: "submit", onClick: googleLogin }, { children: loading ? 'Redirecting you...' : 'Log in with Google' })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 5 }, { children: (0, jsx_runtime_1.jsx)(TextDivider_1.default, { children: "or" }) }))] })), loading && (0, jsx_runtime_1.jsx)(LoadingSingle_1.default, {}), (0, jsx_runtime_1.jsx)(react_final_form_1.Form, __assign({ initialValues: { email: fixedEmail }, validate: (0, validators_1.requiredFields)(['password']), onSubmit: onLogin }, { children: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting, submitError = _a.submitError;
                    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "email", color: "secondary", disabled: true, component: TextField_1.default, validate: validators_1.getEmailError, label: "Email", fullWidth: true }) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "password", color: "secondary", disabled: submitting, component: TextField_1.default, validate: (0, validators_1.required)(), type: "password", label: "Password", fullWidth: true }) })), submitError && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 2, color: "error", align: "center" }, { children: submitError })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 2 }, { children: (0, jsx_runtime_1.jsx)(Button_1.default, __assign({ fullWidth: true, onClick: handleSubmit, type: "submit", isSending: loading }, { children: (loading && 'Logging in') || (needsLogin === 'password' ? 'Log In' : 'Set Password') })) }))] })));
                } }))] })));
};
exports.default = LoginForm;
